import { SensorAPI, PreDragActions, SnapDragActions, FluidDragActions } from "react-beautiful-dnd";
import { info } from "../../services/sentryLogger";

let api: SensorAPI | null = null
let height: number = 0
let moving = false;
const debug = false;
const registerSensor = (s: SensorAPI, itemHeight?: number) => {
    // info('registerSensor', { s })
    api = s
}

const registerHeight = (itemHeight: number) => {
    if(itemHeight > height) {
        debug && info('registerHeight', { itemHeight, height })
        height = itemHeight
    }
}

export const registerEnd = () => {
    debug && info('registerEnd moving')
    moving = false
}

export const registerAutomation =  {
    registerHeight,
    registerSensor,
    registerEnd,
}

const maxStep = 10;
export const fluidMove = function start(draggableId : string, end?: { x: number, y: number }) {
    debug && info('fluidMove', { api, draggableId, end, height })
    end = end || { x: 0, y: height }
    if (!api || !draggableId || (end?.y === 0 && end?.x === 0)) {
        debug && info('fluidMove no api or draggableId or end')
        return
    }
    api.tryReleaseLock();
    const preDrag = api.tryGetLock(draggableId)
    if (!preDrag) {
        debug && info('fluidMove preDrag no lock')
        return
    }
    if(moving) {
        debug && info('fluidMove already moving')
        return
    } else {
        debug && info('fluidMove start moving')
        moving = true
    }
    const start = { x: 0, y: 0 }
    const drag = preDrag.fluidLift(start)
    const points = []
    const deltaX = (end.x - start.x) / maxStep
    const deltaY = (end.y - start.y) / maxStep
    for (let i = 0; i <= maxStep; i++) {
        points.push({
            x: start.x + deltaX * i,
            y: start.y + deltaY * i,
        })
    }
    moveStepByStep(drag, points)
}

export const moveUp = (draggableId: string, nPos: number = 1) => {
    debug && info('moveUp', { nPos })
    fluidMove(draggableId, { x: 0, y: -nPos*height })
}
export const moveDown = (draggableId: string, nPos: number = 1) => {
    debug && info('moveDown', {  nPos })
    fluidMove(draggableId, { x: 0, y: nPos*height })
}

function moveStepByStep(drag: FluidDragActions, values: any) {
    requestAnimationFrame(() => {
        const newPosition = values.shift()
        if (!newPosition) {
            debug && info('drop')
            drag.drop()
            return
        } else {
            debug && info('moveStepByStep', newPosition)
        }
        drag.move(newPosition)

        if (values.length) {
            moveStepByStep(drag, values)
        } else {
            debug && info('drop')
            drag.drop()
        }
    })
}

export function move2Bottom(draggableId: string) {
    info('move2Bottom', { api, draggableId })
    if (!api || !draggableId) {
        return
    }
    // Could not get lock
    const preDrag: PreDragActions | null = api.tryGetLock(draggableId)
    info('preDrag', { preDrag })
    if (!preDrag) {
        return
    }
    const drag: SnapDragActions = preDrag.snapLift()
    info('drag', { drag }, drag.isActive())
    // drag.moveRight()
    // requestAnimationFrame(() => {
    //     drag.moveDown()
    // })
    // requestAnimationFrame(() => {
    //     drag.moveDown()
    // })
    // requestAnimationFrame(() => {
    //     drag.drop()
    // })
    // requestAnimationFrame(() => {
    //     drag.moveDown()
    // })
    // drag.moveDown()
    // drag.moveDown()
    drag.moveDown()
    drag.drop()
}